(function () {
    'use strict';

    angular.module('swif.openbase')

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/configuration/checkup', {
            templateUrl: 'partials/openbase/checkup.html',
            controller: 'OpenbaseCheckup',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }])

    .controller('OpenbaseCheckup', [
        '$scope', 'swifFrameworkService',
        function ($scope, swif) {
            //UN SERVICE N AYANT PAS MATERIEL
            $scope.debug = {};
            $scope.link_map = {
                'partner': '/configuration/partners',
                'partner_address': '/configuration/partners',
                'department': '/configuration/departments',
                'site': '/configuration/sites',
                'team': '/configuration/teams',
                'equipment': '/configuration/equipments',
                'consumable': '/configuration/consumables',
                'consumable_category': '/configuration/consumable_categories',
                'partner_type': '/configuration/partner_types'
            };
            $scope.checkup = [
                {
                    title: 'Organisation(s) sans type',
                    params: {domain: [['type_id', '=', false], ['is_department', '=', false]]},
                    content_type: 'partner',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Organisation(s) interne sans type',
                    params: {domain: [['type_id', '=', false], ['is_department', '=', true]]},
                    content_type: 'partner',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Organisation(s) sans service (technical_service_id)',
                    params: {domain: [['technical_service_id', '=', false], ['is_department', '=', false]]},
                    content_type: 'partner',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Organisation(s) sans contact',
                    params: {domain: [['address', '=', false]]},
                    content_type: 'partner',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Contact(s) sans organisation',
                    params: {domain: [['partner_id', '=', false]]},
                    content_type: 'partner_address',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Utilisateur(s) sans contact',
                    params: {domain: [['contact_id', '=', false]]},
                    category: 'warning',
                    content_type: 'user',
                    edit: $scope.link_map.partner
                },
                /* {
                    title: 'Utilisateur(s) sans prénom ayant un contact',
                    params: {domain: [['firstname', '=', false], ['contact_id', '!=', false]]},
                    content_type: 'user',
                    edit: $scope.link_map.partner
                }, */
                {
                    title: 'Utilisateur(s) sans nom',
                    params: {domain: [['name', '=', false]]},
                    content_type: 'user',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Utilisateur(s) sans login',
                    params: {domain: [['login', '=', false]]},
                    content_type: 'user',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Utilisateur(s) sans droits (groups_id)',
                    params: {domain: [['groups_id', '=', false]]},
                    content_type: 'user',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Utilisateur(s) sans context_lang',
                    params: {domain: [['context_lang', '=', false]]},
                    content_type: 'user',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Utilisateur(s) sans tz',
                    params: {domain: [['context_tz', '=', false]]},
                    content_type: 'user',
                    edit: $scope.link_map.partner,
                    fix: function () {
                        return {context_tz:'Europe/Paris'};
                    }
                },
                {
                    title: 'Utilisateur(s) externe sans email ayant un contact',
                    params: {domain: [['email', '=', false], ['service_id', '=', false], ['contact_id', '!=', false]]},
                    category: 'warning',
                    content_type: 'user',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Service(s) sans nom',
                    params: {domain: [['name', '=', false]]},
                    content_type: 'department',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Service(s) sans code',
                    params: {domain: [['code', '=', false]]},
                    content_type: 'department',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Service(s) sans site',
                    params: {domain: [['site_ids', '=', false]]},
                    category: 'warning',
                    content_type: 'department',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Service(s) sans chef',
                    params: {domain: [['manager_id', '=', false]]},
                    category: 'warning',
                    content_type: 'department',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Service(s) sans agent',
                    params: {domain: [['user_ids', '=', false]]},
                    category: 'warning',
                    content_type: 'department',
                    edit: $scope.link_map.partner
                },
/* ERREUR SERVEUR                {
                    title: 'Site(s) sans nom',
                    params: {domain: [['name', '=', false]]},
                    content_type: 'site',
                    edit: $scope.link_map.partner
                },*/
                {
                    title: 'Site(s) sans type',
                    params: {domain: [['type_id', '=', false]]},
                    category: 'warning',
                    content_type: 'site',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Site(s) sans service',
                    params: {domain: [['service_ids', '=', false]]},
                    category: 'warning',
                    content_type: 'site',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Equipe(s) sans nom',
                    params: {domain: [['name', '=', false]]},
                    content_type: 'team',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Equipe(s) sans chef',
                    params: {domain: [['manager_id', '=', false]]},
                    content_type: 'team',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Equipe(s) sans membre',
                    params: {domain: [['user_ids', '=', false]]},
                    content_type: 'team',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Equipe(s) sans service',
                    params: {domain: [['service_ids', '=', false]]},
                    content_type: 'team',
                    edit: $scope.link_map.partner
                },
/*                {
                    title: 'Equipement(s) sans nom',
                    params: {domain: [['name', '=', false]]},
                    content_type: 'equipment',
                    edit: $scope.link_map.partner
                },*/
                {
                    title: 'Fourniture(s) sans code',
                    params: {domain: [['code', '=', false]]},
                    content_type: 'consumable',
                    category: 'warning',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Fourniture(s) sans type',
                    params: {domain: [['type_id', '=', false]]},
                    content_type: 'consumable',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Fourniture(s) sans prix',
                    params: {domain: [['price', '=', false]]},
                    content_type: 'consumable',
                    edit: $scope.link_map.partner
                },
                {
                    title: 'Aucune catégorie de fourniture',
                    params: {},
                    error_on_empty: true,
                    content_type: 'consumable_category',
                    edit: $scope.link_map.partner
                }
            ];
            var setError = function (check) {
                if (check.category === 'warning') {
                    check.warning = true;
                } else {
                    check.error = true;
                }
            };
            _.forEach($scope.checkup, function (check) {
                swif.data.get(check.content_type, undefined, check.params)
                .then(function (results) {
                    check.results = results;
                    if (results.length === 0) {
                        if (check.error_on_empty) {
                            setError(check);
                        } else {
                            check.success = true;
                        }
                    } else {
                        if (check.error_on_empty) {
                            check.success = true;
                        } else {
                            setError(check);
                        }
                    }
                });
            });
            $scope.toggleShowMore = function (check) {
                if (check.more) {
                    check.more = false;
                } else {
                    check.more = true;
                }
            };
            $scope.showDebug = function (item) {
                if ($scope.debug[item.id]) {
                    $scope.debug[item.id] = false;
                } else {
                    $scope.debug[item.id] = true;
                }
            };
            $scope.fix = function (check, item) {
                if (check.fix && item) {
                    var data = check.fix(item);
                    swif.data.save(check.content_type, item.id, data);
                }
            };
        }
    ]);

})();
